
<div class="theme-1">
    <div id="main">
        <template1-navbar></template1-navbar>
        <main [@routeAnimations]="prepareRoute(outlet)">
            <router-outlet #outlet="outlet"></router-outlet>
        </main>
    </div>
</div>